"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _quickFilterItem = _interopRequireDefault(require("./quick-filter-item"));

var _propTypes = _interopRequireDefault(require("prop-types"));

/* eslint-disable react/jsx-key */
var QuickFilters = function QuickFilters(_ref) {
  var disabled = _ref.disabled,
      categories = _ref.categories,
      filterOnClick = _ref.filterOnClick;
  var QuickFilterList = categories.map(function (category) {
    return /*#__PURE__*/_react["default"].createElement(_quickFilterItem["default"], {
      category: category,
      filterOnClick: filterOnClick,
      disabled: disabled
    });
  });
  return /*#__PURE__*/_react["default"].createElement("div", null, QuickFilterList);
};

QuickFilters.propTypes = {
  categories: _propTypes["default"].object,
  filterOnClick: _propTypes["default"]["function"],
  disabled: _propTypes["default"].bool
};
QuickFilters.defaultProps = {
  categories: [{
    label: "Data missing",
    isActive: false
  }],
  filterOnClick: function filterOnClick() {},
  disabled: false
};
var _default = QuickFilters;
exports["default"] = _default;